import { Button, IconButton, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core'
import { Check, Error, ShoppingCart } from '@material-ui/icons'
import { connect } from 'react-redux'
import {
  getProductsOrders
} from '../../action'
import React, { Component } from 'react'
import './style.scss'
const requests = [] 
const models = [{
  group: 'Acessorios',
  model: 'Cartira',
  checked: true,
  money: 0,
  purchased: 4534
}, {
  group: 'Acessorios',
  model: 'Cartira',
  checked: true,
  money: 0,
  purchased: 4534
}, {
  group: 'Acessorios',
  model: 'Cartira',
  checked: true,
  money: 0,
  purchased: 4534
}, {
  group: 'Acessorios',
  model: 'Cartira',
  checked: true,
  money: 0,
  purchased: 4534
}, {
  group: 'Acessorios',
  model: 'Cartira',
  checked: true,
  money: 0,
  purchased: 4534
}, {
  group: 'Acessorios',
  model: 'Cartira',
  checked: true,
  money: 0,
  purchased: 4534
}, {
  group: 'Acessorios',
  model: 'Cartira',
  checked: true,
  money: 0,
  purchased: 4534
}]



class CartsPage extends Component {
order = {}
  componentDidMount() {
    
    this.props.getProductsOrders()
    //console.log( this.props.products);
    //console.log(this.props.history.location.pathname.split('/')[2])
  }
  

  renderStatus = (letter, description) => (
    <div><strong>{letter}:</strong>{description}</div>
  )

  render() {

    let orders = [];

    if (this.props.products.productsOrders !== undefined) {
      console.log(this.props.products.productsOrders)
      orders = this.props.products.productsOrders; 
    }

    

    var totalCost = 0, totalMoney = 0
    return (
      <div className="carts-page">
        <div className="page-info">Meu carrinho(1866.0 produtos)</div>
        <div className="line" />
        <div className="status-content">
          <div className="title">Status do pedido</div>
          <div className="content">
            {this.renderStatus('A', 'Aberto')}
            {this.renderStatus('T', 'Recebido Total')}
            {this.renderStatus('P', 'Recebido Parcial')}
            {this.renderStatus('E', 'Excluido')}
            {this.renderStatus('B', 'Baixado')}
          </div>
        </div>
        <div className="line" />
        <div className="title">Pedidos</div>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Pedido</TableCell>
              <TableCell>Entrega</TableCell>
              <TableCell>Quantidade</TableCell>
              <TableCell>Valor Venda</TableCell>
              <TableCell>Detalhes</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {orders.map((option, index) => {
              totalCost += option.VALOR_CUSTO.toFixed(2) * 7
              totalMoney += option.VALOR_PEDIDO.toFixed(2) * 7
              return (
                <TableRow key={index}>
                  <TableCell>
                    <div>{option.PED_PEDIDO}</div>
                    <div>{option.PED_OBSERVACAO.substr(0, 12)}</div>
                  </TableCell>
                  <TableCell>{option.PED_FIM_ENTREGA_BR}</TableCell>
                  <TableCell>{option.QTD_PEDIDA}</TableCell>
                  <TableCell>
                    <div>Custo R${option.VALOR_CUSTO.toFixed(2)}</div>
                    <div>Verba R${option.VALOR_PEDIDO.toFixed(2)}</div>
                  </TableCell>
                  <TableCell>
                    <IconButton onClick={()=>this.props.history.push('./cartdetails')}><ShoppingCart /></IconButton>
                    <IconButton><Check /></IconButton>
                    <span>A</span>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
        <div className="line" />
        <div className="title">Total no carrinho</div>
        <Table>
          <TableRow>
            <TableCell>Total custo</TableCell>
            <TableCell>R${totalCost}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Total venda</TableCell>
            <TableCell>R${totalMoney}</TableCell>
          </TableRow>
        </Table>
        <div className="line" />
        <div className="title">Valores por modelo</div>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Grupo</TableCell>
              <TableCell>Modelo</TableCell>
              <TableCell>Verba</TableCell>
              <TableCell>Comprado</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {models.map((element, index) => {
              return (
                <TableRow key={index}>
                  <TableCell>
                    {element.group}
                  </TableCell>
                  <TableCell>{element.model}{element.checked ? <Check /> : <Error />}</TableCell>
                  <TableCell>R${element.money.toFixed(2)}</TableCell>
                  <TableCell>R${element.purchased.toFixed(2)}</TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
        <div className="action">
          <Button>Fechar pedidos</Button>
        </div>
      </div>
    )
  }
}

//export default CartsPage

const mapStateToProps = ({ products }) => ({
  products
})


export default connect(mapStateToProps, {
  getProductsOrders
})(CartsPage)